import React, { useEffect } from "react";
import "../Pages/CleeQ.css";
import "../Pages/Responsive.css";
import { makeStyles } from "@material-ui/core/styles";
// import OurLanding from "./OurLanding";
import Aos from "aos";
import "aos/dist/aos.css";
import ContactUs from "./ContactUs";
import "../Components/NavBar/NavBar.css";
import NavBar from "../Components/NavBar/NavBar";
import SocialHeadings from "../Components/SocialHeadings";

// const NavBar = () => {
//   return (
//     <div className="container NavBarContainer p-0">
//       <div>
//         <SoleraLogo />
//       </div>
//       <div>
//       <NavBarList/>
//       </div>

//       <div className="SignUpAndLoginContianer22">
//         <SignUpAndLogin />
//       </div>
//     </div>
//   );
// };

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

function News() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.scrollTo(0, 0); // This will scroll the page to the top when the component mounts
  }, []);

  const classes = useStyles();

  return (
    <div>
      <header className="SoleraSticky">
      <div className="SocialHeadings-Display">
          <SocialHeadings />
        </div>
        {/* <div className="container-fluid p-0">
          <div className="EmailNavHeader">
          <SocialHeadings/>
          </div>
        </div> */}
        <NavBar />
      </header>

      {/* <div id="Home">
        <OurLanding />
      </div> */}
      {/* <div id="AboutUs">
        <AboutUs />
      </div> */}
      {/* <div id="Events">
        <Events />
      </div> */}

      <div id="News">
        <div>
          <div className="SoleraBody442">
            <div className="container EventOthers landing-page-container">
              <div>
                <div className="LandingHedings1" data-aos="zoom-in-up">
                  News
                </div>
                <div className="NO-Events">
                  "Stay tuned! Exciting updates are on the way, so keep your
                  eyes peeled for what's coming next!"
                </div>
              </div>
              <br />
              <br />
              <br />
              <div className="container-fluid p-0">
                <div className="row g-2">
                  <div className="col">
                    <div className=" EventPics"></div>
                  </div>
                </div>
              </div>
              {/* <div className="SeeMore">See More</div> */}
            </div>
          </div>
        </div>
      </div>
      
      <div id="Projects">
        <div>
          <div className="SoleraBody303">
            <div className="container EventOthers landing-page-container">
              <div>
                <div className="LandingHedings1" data-aos="zoom-in-up">
                  Projects
                </div>
                <div className="NO-Events">
                  Stay tuned for our next big venture!"
                </div>
              </div>
              <br /> <br /> <br />
              <div className="container-fluid p-0">
                <div className="row g-2">
                  <div className="col">
                    <div className=" EventPics"></div>
                  </div>
                </div>
              </div>
              {/* <div className="SeeMore">See More</div> */}
            </div>
          </div>
        </div>
      </div>

      <div id="Photo Gallery">
        <ContactUs />
      </div>
    </div>
  );
}

export default News;
